export * from './MarketRegisterClassicIcon';
export * from './MarketRegisterClassicIcon16Light';
export * from './MarketRegisterClassicIcon16Regular';
export * from './MarketRegisterClassicIcon16Solid';
export * from './MarketRegisterClassicIcon20Light';
export * from './MarketRegisterClassicIcon20Regular';
export * from './MarketRegisterClassicIcon20Solid';
export * from './MarketRegisterClassicIcon24Regular';
export * from './MarketRegisterClassicIcon24Solid';
export * from './MarketRegisterClassicIcon32Regular';
export * from './MarketRegisterClassicIcon64Regular';
